/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    height: PropTypes.string,
    width: PropTypes.string,
    color: PropTypes.oneOf(['primary', 'secondary']),
    shape: PropTypes.oneOf(['circle', 'rect']),
};

const defaultProps = {
    ...commonDefaultProps,
    height: '42px',
    width: '100%',
    color: 'secondary',
    shape: 'rect',
};

const Placeholder = (props) => {
    const classNames = [
        'c-placeholder',
        `c-placeholder--${props.color}`,
        `c-placeholder--${props.shape}`,
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    const {
        width,
        height,
        style,
    } = props;
    const placeholderStyle = {
        width,
        height,
        ...style,
    };
    return (
        <props.componentClass
            style={placeholderStyle}
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        />
    );
};

Placeholder.propTypes = propTypes;

Placeholder.defaultProps = defaultProps;

export default Placeholder;
